/**
 * React Admin's Save Button with hidden icon
 *
 * <SaveButton> used in <SimpleForm> by default display an icon in the button. This component hide icon and inherit functionality from <SaveButton>
 *
 * Docs:
 * https://www.styled-components.com/
 *
 */

import React from 'react';
import styled from 'styled-components';
import { SaveButton } from 'react-admin';

const SaveButtonWithoutIcon = styled(SaveButton)`
  & span > svg {
    display: none;
  }
`;

export default SaveButtonWithoutIcon;
